module.exports = __webpack_public_path__ + "img/small_new_paradigm.96dc421c.png";